import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { CommandPanels, EditorControls, withBaseEditor } from '../../BaseEditor';

function EditorRenderer({
  getControl, currentUser, fields, data, dataSetter,
}) {
  return (
    <Grid container spacing={2}>
      {currentUser.is_superuser && (
        <Grid item sm={12}>
          {getControl('org', {
            backend: '/api/catalog/orgs/',
          })}
        </Grid>
      )}
      <Grid item sm={12} display="flex" container spacing={2}>
        <Grid item sm={3}>
          {getControl('series')}
        </Grid>
        <Grid item sm={6}>
          {getControl('number')}
        </Grid>
      </Grid>
      <Grid item sm={12} display="flex" container spacing={2}>
        <Grid item sm={3}>
          {getControl('registration_date')}
        </Grid>
        <Grid item sm={6}>
          {getControl('registration_number')}
        </Grid>
        <EditorControls.TextInput
          label={fields.notes.label}
          readOnly={fields.notes.read_only}
          required={fields.notes.required}
          value={data.notes}
          onChange={(e, v) => dataSetter({ notes: v })}
        />
      </Grid>
    </Grid>
  );
}

EditorRenderer.propTypes = {
  getControl: PropTypes.func.isRequired,
  dataSetter: PropTypes.func.isRequired,
  currentUser: PropTypes.shape({
    org: PropTypes.shape({
      id: PropTypes.number,
      repr: PropTypes.string,
      addr_prefix: PropTypes.string,
    }),
    is_superuser: PropTypes.bool,
  }).isRequired,
  fields: PropTypes.shape({
    notes: PropTypes.shape({
      label: PropTypes.string,
      required: PropTypes.bool,
      read_only: PropTypes.bool,
    }),
  }).isRequired,
  data: PropTypes.shape({
    notes: PropTypes.string,
  }).isRequired,
};

export default withBaseEditor(EditorRenderer, '/api/realty/landcertificate/', CommandPanels.catCommandPanel);
